// extracted by mini-css-extract-plugin
export var active = "index-module--active--09804";
export var content_wrapper = "index-module--content_wrapper--3f455";
export var cover_item_wrapper = "index-module--cover_item_wrapper--bbdd5";
export var cover_wrapper = "index-module--cover_wrapper--e210f";
export var feature_content_item = "index-module--feature_content_item--69667";
export var feature_content_wrapper = "index-module--feature_content_wrapper--51894";
export var feature_cover = "index-module--feature_cover--4b79c";
export var feature_title = "index-module--feature_title--ac2fd";
export var slice_content_text_wrapper = "index-module--slice_content_text_wrapper--69522";
export var slice_content_wrapper = "index-module--slice_content_wrapper--30f88";
export var swiper_bullet = "index-module--swiper_bullet--8bbea";
export var swiper_bullet_active = "index-module--swiper_bullet_active--b3714";
export var swiper_wrapper = "index-module--swiper_wrapper--93a6a";
export var tips_item = "index-module--tips_item--a2f5d";
export var wrapper = "index-module--wrapper--54d98";